import React, { useContext } from 'react'
import { OffreModel } from '../types/OffreModel'
import { Grid } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import AutresElementsCrossSelling from '../../../components/swiper/AutresElementsCrossSelling'
import { ResponsiveContext } from '../../../utils/context/ResponsiveContext'
import styles from '../../../styles'
import { FormattedMessage, useIntl } from 'react-intl'
import { GRIS } from '../../../theme'
import { formatOffreSimilaireModel } from '../../../components/swiper/utils/autresElementsCrossSellingUtils'

const useStyles = makeStyles<{ isLargeScreen: boolean }>()(
	(theme, { isLargeScreen }) => ({
		offresLieesContainer: {
			backgroundColor: GRIS,
			paddingTop: isLargeScreen ? 103 : 60,
			paddingLeft: isLargeScreen ? 65 : 30
		},
		offresLieesContainerSansResidence: {
			borderRadius: '30px 30px 0 0',
			marginTop: isLargeScreen ? -30 : -80,
			position: 'relative',
			zIndex: 2
		},
		titre: {
			...styles(theme).title0,
			fontSize: isLargeScreen ? 45 : 35,
			margin: 0,
			marginBottom: 40,
			paddingRight: isLargeScreen ? 65 : 30,

			'& strong': {
				color: theme.palette.green.main
			}
		},
		swiperContainerStyle: {
			paddingBottom: isLargeScreen ? 98 : 87
		}
	})
)

interface AcceptingProps {
	offre: OffreModel
}

type OffresLieesProps = AcceptingProps

const OffresLiees: React.FC<OffresLieesProps> = (
	{
		offre
	}
) => {
	const { isLargeScreen } = useContext(ResponsiveContext)
	const { classes, cx } = useStyles({ isLargeScreen })
	const intl = useIntl()

	return (
		<>
			<Grid
				container
				item
				xs={12}
				className={
					cx(
						classes.offresLieesContainer,
						{
							[classes.offresLieesContainerSansResidence]: !offre.residence.residencePubliee
						}
					)
				}
			>
				<Grid container item xs={12}>
					<h2 className={classes.titre}>
						<FormattedMessage
							id={`offre.offresLiees.titre.${offre.type}`}
							defaultMessage="<strong>Découvrez aussi</strong> ces appartements à louer"
							description="Titre des offres liées"
							values={{
								strong: (chunk) => <strong>{chunk}</strong>
							}}
						/>
					</h2>
				</Grid>
			</Grid>

			<AutresElementsCrossSelling
				elementsCrossSelling={
					offre.offresSimilaires
						.slice(0, 9)
						.map((offreSimilaire) => formatOffreSimilaireModel(offreSimilaire, intl, 261, 207))
				}
				type={offre.type}
				width={300}
				height="100%"
				spaceBetweenSlides={isLargeScreen ? 36 : 24}
				codePostal={offre.residence.codePostal}
				swiperContainerStyle={classes.swiperContainerStyle}
			/>
		</>
	)
}

export default OffresLiees